import { render, staticRenderFns } from "./GenomeShow.vue?vue&type=template&id=254d8bd1&"
import script from "./GenomeShow.vue?vue&type=script&lang=js&"
export * from "./GenomeShow.vue?vue&type=script&lang=js&"
import style0 from "./GenomeShow.vue?vue&type=style&index=0&id=254d8bd1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports